const n = "{{currentTime}} von {{duration}}", e = "Suchergebniss {{current}} von {{total}}", t = "Keine Ergebnisse gefunden", s = "{{count}} Ergebnis gefunden", c = "{{count}} Ergebnisse gefunden", o = 'Abspielen ab $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) und $t(SECONDS, { "count": {{seconds}} }).', i = 'Abspielen ab $t(MINUTES, { "count": {{minutes}} }) und $t(SECONDS, { "count": {{seconds}} }).', A = 'Abspielen ab $t(SECONDS, { "count": {{seconds}} }).', r = "Fehler beim Speichern der Änderungen am Transkript.", E = "Transkriptzeile bei {{time}}. Inhalt ist: {{text}}.", T = 'Container für Transkriptzeilen. Dort $t(TRANSCRIPT_LINES, { "count": {{count}} }) innerhalb dieses Containers. Um innerhalb dieses Containers zu navigieren, drücken Sie die Nach-Unten-Pfeiltaste.', S = "Änderungen werden gespeichert ...", _ = "Änderungen im Transkript gespeichert.", u = "Schaltfläche „Aktualisierung der Untertitel“ ist nun verfügbar.", a = "Aktion", N = "Anmerkung hinzufügen um {{time}}", R = "Frage hinzufügen um {{time}}", O = "Anmerkungen", I = "Automatisch", h = "Automatisch ({{quality}})", C = "Zurück", P = "Untertitel", U = "Sprache der Untertitel", g = "Untertitel verwalten", l = "{{language}} löschen", d = "Schriftgröße", L = "Untertitelsprache: {{language}}", D = "{{language}} (Automatisch)", m = "Suche löschen", k = "Schließen", M = "Kommentare", b = "Weiter", p = "Wiedergabegeschwindigkeit verringern", f = "Lautstärke verringern um {{percent}}%", G = "Pfeil nach unten", Y = "Transkript-Editor schließen", V = "Aktualisierung der Untertitel", H = "Fehler!", W = "Speichervorgang läuft ...", z = "Gespeichert", B = "Transkript bearbeiten", K = "Der Text darf nicht leer sein!", w = "Vollbild", F = "{{count}} Stunde", v = "{{count}} Stunden", Q = "Wiedergabegeschwindigkeit erhöhen", $ = "Lautstärke erhöhen um {{percent}}%", Z = "Farben invertieren", J = "Zu einem bestimmten Prozentsatz springen (1–10 %, 2–20 % usw.)", x = "Zum Anfang springen", X = "Aktionen für {{title}}", q = "Tastenkombinationen", y = "Sprache", j = "Pfeil nach links", nn = "Hauptmenü", en = "{{count}} Minute", tn = "{{count}} Minuten", sn = "Still", cn = "Stummgeschaltet", on = "Nächste Untertitelsprache", An = "Nächstes Suchergebnis", rn = "Aus", En = "Oben", Tn = "Kommentar öffnen um {{time}}", Sn = "Abgeschlossenes Quiz öffnen um {{time}}", _n = "Quiz öffnen um {{time}}", un = "Pause", an = "Abspielen", Nn = "Wiedergabegeschwindigkeit", Rn = "Wiedergabegeschwindigkeit: {{speed}}x", On = "Vorherige Untertitelsprache", In = "Vorheriges Suchergebnis", hn = "Qualität", Cn = "Qualitätsmenü", Pn = "Wiedergabe", Un = "Wiedergabegeschwindigkeit zurücksetzen", gn = "Pfeil nach rechts", ln = "Im Transkript suchen", dn = "{{count}} Sekunde", Ln = "{{count}} Sekunden", Dn = "Rückwärts suchen: {{seconds}} Sekunden", mn = "Vorwärts suchen: {{seconds}} Sekunden", kn = "Einstellungen", Mn = "Shortcut", bn = "Mediendetails und Werkzeuge", pn = "Leertaste", fn = "Menü für Wiedergabegeschwindigkeit", Gn = "Automatisches Scrollen starten", Yn = "Beschriftungen ein-/ausschalten", Vn = "Stummschaltung ein-/ausschalten", Hn = "Wiedergabe/Pause ein-/ausschalten", Wn = "ist {{count}} Transkriptzeile", zn = "sind {{count}} Transkriptzeilen", Bn = "Transkript wird geladen ...", Kn = "Das Transkript konnte nicht geladen werden.", wn = "Transkript-Optionen", Fn = "Erneut versuchen", vn = "Transkript nicht verfügbar", Qn = "Pfeil nach oben", $n = "Video-Einstellungen", Zn = "Lautstärke", Jn = "Lautstärke: {{volume}}%", xn = {
  A11Y_DURATION: n,
  A11Y_SEARCH_HITS: e,
  A11Y_SEARCH_NO_RESULTS: t,
  A11Y_SEARCH_RESULTS_FOUND: s,
  A11Y_SEARCH_RESULTS_FOUND_other: c,
  A11Y_TIMESTAMP_JUMP_HOURS: o,
  A11Y_TIMESTAMP_JUMP_MINUTES: i,
  A11Y_TIMESTAMP_JUMP_SECONDS: A,
  A11Y_TRANSCRIPT_ERROR: r,
  A11Y_TRANSCRIPT_LINE: E,
  A11Y_TRANSCRIPT_LINES: T,
  A11Y_TRANSCRIPT_SAVING: S,
  A11Y_TRANSCRIPT_SUCCESS: _,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: u,
  ACTION: a,
  ADD_ANNOTATION_AT: N,
  ADD_QUESTION_AT: R,
  ANNOTATIONS: O,
  AUTO: I,
  AUTO_QUALITY: h,
  BACK: C,
  CAPTIONS: P,
  CAPTIONS_LANGUAGE: U,
  CAPTIONS_MANAGE: g,
  CAPTION_DELETE: l,
  CAPTION_FONT_SIZE: d,
  CAPTION_LANGUAGE: L,
  CAPTION_LANGUAGE_AUTOMATIC: D,
  CLEAR_SEARCH: m,
  CLOSE: k,
  COMMENTS: M,
  CONTINUE: b,
  DECREASE_PLAYBACK_SPEED: p,
  DECREASE_VOLUME: f,
  DOWN_ARROW: G,
  EDIT_CLOSE: Y,
  EDIT_CONFIRM: V,
  EDIT_ERROR: H,
  EDIT_SAVING: W,
  EDIT_SUCCESS: z,
  EDIT_TRANSCRIPT: B,
  EDIT_VALIDATION_ERROR: K,
  FULLSCREEN: w,
  HOURS: F,
  HOURS_other: v,
  INCREASE_PLAYBACK_SPEED: Q,
  INCREASE_VOLUME: $,
  INVERT_COLORS: Z,
  JUMP_TO_PERCENTAGE: J,
  JUMP_TO_START: x,
  KEBAB_MENU: X,
  KEYBOARD_SHORTCUTS: q,
  LANGUAGE: y,
  LEFT_ARROW: j,
  MAIN_MENU: nn,
  MINUTES: en,
  MINUTES_other: tn,
  MUTE: sn,
  MUTED: cn,
  NEXT_CAPTION_LANGUAGE: on,
  NEXT_HIT: An,
  OFF: rn,
  ON_TOP: En,
  OPEN_ANNOTATION_AT: Tn,
  OPEN_COMPLETED_QUIZ_AT: Sn,
  OPEN_QUIZ_AT: _n,
  PAUSE: un,
  PLAY: an,
  PLAYBACK_SPEED: Nn,
  PLAYBACK_SPEED_MESSAGE: Rn,
  PREVIOUS_CAPTION_LANGUAGE: On,
  PREVIOUS_HIT: In,
  QUALITY: hn,
  QUALITY_MENU: Cn,
  REPLAY: Pn,
  RESET_PLAYBACK_SPEED: Un,
  RIGHT_ARROW: gn,
  SEARCH_TRANSCRIPT_PLACEHOLDER: ln,
  SECONDS: dn,
  SECONDS_other: Ln,
  SEEK_BACKWARD: Dn,
  SEEK_FORWARD: mn,
  SETTINGS: kn,
  SHORTCUT: Mn,
  SIDEBAR: bn,
  SPACE: pn,
  SPEED_MENU: fn,
  START_AUTOSCROLL: Gn,
  TOGGLE_CAPTIONS: Yn,
  TOGGLE_MUTED: Vn,
  TOGGLE_PLAY_PAUSE: Hn,
  TRANSCRIPT_LINES: Wn,
  TRANSCRIPT_LINES_other: zn,
  TRANSCRIPT_LOADING: Bn,
  TRANSCRIPT_LOAD_ERROR: Kn,
  TRANSCRIPT_OPTIONS: wn,
  TRANSCRIPT_RETRY: Fn,
  TRANSCRIPT_UNAVAILABLE: vn,
  UP_ARROW: Qn,
  VIDEO_SETTINGS: $n,
  VOLUME: Zn,
  VOLUME_VALUE: Jn
};
export {
  n as A11Y_DURATION,
  e as A11Y_SEARCH_HITS,
  t as A11Y_SEARCH_NO_RESULTS,
  s as A11Y_SEARCH_RESULTS_FOUND,
  c as A11Y_SEARCH_RESULTS_FOUND_other,
  o as A11Y_TIMESTAMP_JUMP_HOURS,
  i as A11Y_TIMESTAMP_JUMP_MINUTES,
  A as A11Y_TIMESTAMP_JUMP_SECONDS,
  r as A11Y_TRANSCRIPT_ERROR,
  E as A11Y_TRANSCRIPT_LINE,
  T as A11Y_TRANSCRIPT_LINES,
  S as A11Y_TRANSCRIPT_SAVING,
  _ as A11Y_TRANSCRIPT_SUCCESS,
  u as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  a as ACTION,
  N as ADD_ANNOTATION_AT,
  R as ADD_QUESTION_AT,
  O as ANNOTATIONS,
  I as AUTO,
  h as AUTO_QUALITY,
  C as BACK,
  P as CAPTIONS,
  U as CAPTIONS_LANGUAGE,
  g as CAPTIONS_MANAGE,
  l as CAPTION_DELETE,
  d as CAPTION_FONT_SIZE,
  L as CAPTION_LANGUAGE,
  D as CAPTION_LANGUAGE_AUTOMATIC,
  m as CLEAR_SEARCH,
  k as CLOSE,
  M as COMMENTS,
  b as CONTINUE,
  p as DECREASE_PLAYBACK_SPEED,
  f as DECREASE_VOLUME,
  G as DOWN_ARROW,
  Y as EDIT_CLOSE,
  V as EDIT_CONFIRM,
  H as EDIT_ERROR,
  W as EDIT_SAVING,
  z as EDIT_SUCCESS,
  B as EDIT_TRANSCRIPT,
  K as EDIT_VALIDATION_ERROR,
  w as FULLSCREEN,
  F as HOURS,
  v as HOURS_other,
  Q as INCREASE_PLAYBACK_SPEED,
  $ as INCREASE_VOLUME,
  Z as INVERT_COLORS,
  J as JUMP_TO_PERCENTAGE,
  x as JUMP_TO_START,
  X as KEBAB_MENU,
  q as KEYBOARD_SHORTCUTS,
  y as LANGUAGE,
  j as LEFT_ARROW,
  nn as MAIN_MENU,
  en as MINUTES,
  tn as MINUTES_other,
  sn as MUTE,
  cn as MUTED,
  on as NEXT_CAPTION_LANGUAGE,
  An as NEXT_HIT,
  rn as OFF,
  En as ON_TOP,
  Tn as OPEN_ANNOTATION_AT,
  Sn as OPEN_COMPLETED_QUIZ_AT,
  _n as OPEN_QUIZ_AT,
  un as PAUSE,
  an as PLAY,
  Nn as PLAYBACK_SPEED,
  Rn as PLAYBACK_SPEED_MESSAGE,
  On as PREVIOUS_CAPTION_LANGUAGE,
  In as PREVIOUS_HIT,
  hn as QUALITY,
  Cn as QUALITY_MENU,
  Pn as REPLAY,
  Un as RESET_PLAYBACK_SPEED,
  gn as RIGHT_ARROW,
  ln as SEARCH_TRANSCRIPT_PLACEHOLDER,
  dn as SECONDS,
  Ln as SECONDS_other,
  Dn as SEEK_BACKWARD,
  mn as SEEK_FORWARD,
  kn as SETTINGS,
  Mn as SHORTCUT,
  bn as SIDEBAR,
  pn as SPACE,
  fn as SPEED_MENU,
  Gn as START_AUTOSCROLL,
  Yn as TOGGLE_CAPTIONS,
  Vn as TOGGLE_MUTED,
  Hn as TOGGLE_PLAY_PAUSE,
  Wn as TRANSCRIPT_LINES,
  zn as TRANSCRIPT_LINES_other,
  Bn as TRANSCRIPT_LOADING,
  Kn as TRANSCRIPT_LOAD_ERROR,
  wn as TRANSCRIPT_OPTIONS,
  Fn as TRANSCRIPT_RETRY,
  vn as TRANSCRIPT_UNAVAILABLE,
  Qn as UP_ARROW,
  $n as VIDEO_SETTINGS,
  Zn as VOLUME,
  Jn as VOLUME_VALUE,
  xn as default
};
